import { Link } from "react-router-dom";
import Logo from "./Logo";
import { SITE, SERVICES } from "../data/site";
import { CITIES } from "../data/cities";

export default function Footer() {
    return (
        <footer className="border-t border-linew bg-coal/70 mt-auto" data-testid="footer">
            <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
                <div>
                    <Logo chip />
                    <p className="mt-6 text-sm leading-relaxed text-smoke">
                        Artisan peintre et poseur de revêtements de sol basé à
                        {" "}{SITE.city} ({SITE.dept}). Intervention dans un rayon de 40 km :
                        {" "}Vexin français, Oise sud-ouest et Val-d'Oise nord.
                    </p>
                    <div className="mt-6 space-y-2 text-sm">
                        <a href={SITE.phoneHref} className="block text-gold font-semibold hover:text-gold-light transition-colors" data-testid="footer-phone">
                            {SITE.phoneDisplay}
                        </a>
                        <a href={`mailto:${SITE.email}`} className="block text-ivory/75 hover:text-gold transition-colors" data-testid="footer-email">
                            {SITE.email}
                        </a>
                        <a
                            href={SITE.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 text-ivory/75 hover:text-gold transition-colors"
                            data-testid="footer-instagram"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                <rect x="2" y="2" width="20" height="20" rx="5" />
                                <circle cx="12" cy="12" r="4" />
                                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
                            </svg>
                            @solinopro
                        </a>
                        <p className="text-smoke">{SITE.hours}</p>
                    </div>
                </div>

                <nav aria-label="Services">
                    <p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold mb-6">Services</p>
                    <ul className="space-y-3 text-sm">
                        {SERVICES.map((s) => (
                            <li key={s.slug}>
                                <Link to={`/${s.slug}`} className="text-ivory/75 hover:text-gold transition-colors" data-testid={`footer-service-${s.slug}`}>
                                    {s.nav}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <nav aria-label="Zones desservies">
                    <p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold mb-6">Zones desservies</p>
                    <ul className="space-y-3 text-sm">
                        {CITIES.map((c) => (
                            <li key={c.slug}>
                                <Link to={`/peintre-${c.slug}`} className="text-ivory/75 hover:text-gold transition-colors" data-testid={`footer-city-${c.slug}`}>
                                    {c.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div>
                    <p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold mb-6">Confiance</p>
                    <ul className="space-y-3 text-sm text-ivory/75">
                        <li data-testid="footer-decennale">{SITE.decennale}</li>
                        <li data-testid="footer-siret">{SITE.siret}</li>
                        <li>
                            <Link to="/plan-marketing" className="hover:text-gold transition-colors" data-testid="footer-plan-marketing">
                                Plan marketing
                            </Link>
                        </li>
                        <li>
                            <Link to="/mentions-legales" className="hover:text-gold transition-colors" data-testid="footer-mentions">
                                Mentions légales
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-linew">
                <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-smoke">
                    <span>© {new Date().getFullYear()} Solino Pro — {SITE.city} ({SITE.dept})</span>
                    <span>Peintre &amp; revêtement de sol · Devis gratuit sous 48 h</span>
                </div>
            </div>
        </footer>
    );
}
